import { colorPalette } from '@sharefiledev/antd-config';
import {
	Col,
	ConfigProvider,
	Flex,
	Grid,
	Row,
	Steps,
	Tag,
	theme,
	Typography,
} from 'antd';
import { useAppStore } from '../../../common/store';
import { t } from '../../../utils';
import { getStepsConfig } from '../stepsConfig';

const { Title } = Typography;

const { useBreakpoint } = Grid;

export const SignatureRequestHeader = () => {
	const { signatureMetadata } = useAppStore(state => ({
		signatureMetadata: state.signatureMetadata,
	}));

	const breakpoints = useBreakpoint();
	const isWideScreen = breakpoints.xl; // (Extra-large): Screen width equal to or greater than 1200px
	const isMobile = breakpoints.xs; // (Extra-small): Screen width less than 576px

	const steps = getStepsConfig(signatureMetadata.numberOfsteps, isMobile);

	const { token } = theme.useToken();

	return (
		<Row>
			{isWideScreen && (
				<Col span={steps.length === 2 ? 10 : 8}>
					<Flex align="center" gap="small" style={{ margin: token.marginXS }}>
						<Title level={4} style={{ margin: '0px' }}>
							{t('SendSignatureRequest.title')}
						</Title>
						<Tag>{t('SendSignatureRequest.tag')}</Tag>
					</Flex>
				</Col>
			)}

			<Col span={!isWideScreen ? 22 : steps.length === 2 ? 7 : 12}>
				<ConfigProvider
					theme={{
						components: {
							Steps: {
								colorPrimary: colorPalette.green8,
								controlItemBgActive: colorPalette.green8,
								fontSize: 14,
							},
						},
					}}
				>
					<Steps
						items={steps}
						size="small"
						responsive={false} // Disable Change to vertical direction when screen width smaller than 532px
						style={{
							height: '100%',
							alignItems: 'center',
							fontStyle: 'normal',
							fontWeight: 400,
						}}
					/>
				</ConfigProvider>
			</Col>
		</Row>
	);
};
